import { Dispatch } from "redux";
import {
    deleteAccessoryFailure,
    deleteAccessoryRequest,
    deleteAccessorySuccess,
    getAccessoriesFailure,
    getAccessoriesRequest,
    getAccessoriesSuccess,
    postAccessoryFailure,
    postAccessoryRequest,
    postAccessorySuccess,
} from "src/store/actions/accessories";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { deleteTo, getFromAuthed, postTo } from "./shared/osfetch";
import { findRoute } from "./util";
import {
    getCreditAppSettingsRequest,
    getCreditAppSettingssFailure,
    getCreditAppSettingsSuccess,
} from "src/store/actions/creditApp/settings";
import { logError } from "src/utils/logger";

const getCreditAppSettings = async (
    next: Dispatch,
    { payload: { creditApiUrl, creditAppDealerId, afterFetch } }: ActionType<typeof getCreditAppSettingsRequest>
) => {
    try {
        const response = await fetch(`${creditApiUrl}dealer/${creditAppDealerId}/form_data`, {
            method: "GET",
            headers: { accept: "application/json" },
            mode: "cors",
        });

        const settingsData = await response.json();

        if (!response.ok) {
            console.log(`Form data fetch failure: ${settingsData.message}`);
            // eslint-disable-next-line no-throw-literal
            throw { name: "Non200CreditAppError", code: response.status, responseBody: settingsData };
        }

        next(getCreditAppSettingsSuccess(settingsData));
    } catch (error) {
        logError(error);

        getCreditAppSettingssFailure();
    }

    if (afterFetch) {
        afterFetch();
    }
};

const routes = {
    [getCreditAppSettingsRequest.type]: getCreditAppSettings,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
